var ScreenSizeService = /** @class */ (function () {
    function ScreenSizeService() {
        this.breakpoints = {
            $breakSmall: 475,
            $breakTablet: 768,
            $breakWide: 1024,
            $breakWidest: 1600
        };
        this.windowRef = window;
    }
    Object.defineProperty(ScreenSizeService.prototype, "isMobile", {
        get: function () {
            return this.windowRef.innerWidth <= this.breakpoints.$breakSmall;
        },
        enumerable: true,
        configurable: true
    });
    return ScreenSizeService;
}());
export { ScreenSizeService };



// WEBPACK FOOTER //
// ./src/app/services/screen-size.service.ts.pre-build-optimizer.js